<template>
  <div class="avatarUrl">
    <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
        <div class="dl-top">
          <div class="dl-title fl">修改头像</div>
          <div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
        </div>
        <div class="main">
           <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    :action="domain"
                    accept="image/jpeg,image/gif,image/png,image/bmp"
                    :headers="myHeader"
                    :http-request="uploadFile"
                    :on-change="changeFile"
                    :show-file-list="false"
                    :auto-upload="false"
                    list-type="picture"
                    :multiple="false">
                    <img v-if="BinaryImg" :src="BinaryImg" class="avatar" >
                    <i v-else class="el-icon-plus avatar-uploader-icon"><span>选择图片</span></i>
            </el-upload> 
        </div>

        <div class="dl-footer">
             <el-row  align="middle"  type="flex" class="mb20"> 
              <el-col :span="14"><div class="grid-content bg-purple"></div></el-col>
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-button type="primary" size="small" @click="closeWindow">取消</el-button>
                  <el-button type="primary" size="small" @click="editEwm">更换</el-button>
                </div>
              </el-col>
            </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'avatarUrl',
  props:{
    isShow:Boolean,
    AvatarUrl:String
  },
  data () {
    return {
      isShowMe:this.isShow,
      BinaryImg:'',
      fileUid:0,
    }
  },
  computed:{
    domain(){
       return this.$store.getters.domain+'ImgBase64Upload1';
    },
    myHeader(){
      return {"content-type":"multipart/form-data"}
    },
     loading(){
       return this.$store.getters.loadingPara;
     }
  },
  methods: {
   closeWindow(){
			this.isShowMe=false;
   },
   changeFile(file,fileList){
       this.fileUid=file.uid;
       this.BinaryImg=file.url;
   },
   checkUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isGIF && !isPNG && !isBMP) {
            this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定'});
        }else if(!isLt2M) {
            this.$alert('上传图片大小不能超过 2MB!', '提示', {confirmButtonText: '确定'});
        }
        return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
   },
   uploadFile: function (fileObj) {     //上传图片成功后发布订单
       const loading = this.$loading(this.loading);
       var file=fileObj.file;
       if(file.uid==this.fileUid){
       var b=this.checkUpload(file);
       if(b){
            const self = this;
            var reader = new FileReader();
            reader.onload = function(event) {
            // event.target.result 即为图片的Base64编码字符串
            var imsJson = [{
              "value": event.target.result,
              "name":'111'
            }];
            var json={"file":imsJson,"SerialNo":self.SerialNo}
            self.http.ajaxPost('ImgBase64Upload1',json,"",function(data){
                loading.close();
                self.$alert(data.Message, '提示', {confirmButtonText: '确定'});
                if(data.ReturnCode==1){
                  //更新头像
                  var data1 = self.common.GetlocalStorage("UnLockUserData");
			            var obj=JSON.parse(data1);
                  obj.AvatarUrl=data.Result[0];
                  self.common.SetlocalStorage(JSON.stringify(obj),"UnLockUserData");
                  self.closeWindow();
                  self.$emit("on-success",data.Result[0]);
                }
            },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
          }
          reader.readAsDataURL(file);
        }
      }
    },
    editEwm(){
      this.$refs.upload.submit();
    }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        this.BinaryImg=this.AvatarUrl;
      }else{
        this.$emit("on-close",val);
      }
    }
  },
  mounted: function () {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.avatarUrl .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:999; }
.avatarUrl	.detailList{width:385px;height:470px;position: fixed; top:50%; left:50%; margin-left:-192.5px; margin-top:-235px;  z-index:999; background: #fff; }
.avatarUrl	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
.avatarUrl	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
.avatarUrl	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
.avatarUrl	.detailList .dl-close img{ cursor: pointer;}
.avatarUrl  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:325px; padding:0 30px;}
.avatarUrl  .detailList .main{ padding:30px 50px; font-size:16px; color:#444;}
.avatarUrl  .mb20{margin-bottom:20px;}
.avatarUrl  .hide{ display: none;}
.avatarUrl  .avatar-uploader{cursor:pointer;overflow:hidden; float: left; vertical-align: bottom;}
.avatarUrl  .avatar-uploader-icon:hover {border-color:#409EFF;}
.avatarUrl  .avatar-uploader-icon {font-size:38px;color:#8c939d;width:128px;height:98px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px; padding-top:30px;}
.avatarUrl  .avatar-uploader-icon span{ font-size:16px; display: block; padding-top:10px;}
.avatarUrl  .avatar{ max-width: 286px; max-height:286px;}
</style>



// WEBPACK FOOTER //
// src/components/avatar.vue